import React from 'react'
import { Tabs } from 'antd'
import { TabsProps } from 'antd/lib/tabs'
import { useHistory, useParams } from 'react-router'

type PathStyle = 'hash' | 'slash'
interface ITabbedView extends TabsProps {
    children: any
    availablePathKeys: string[]
    pathStyle?: PathStyle
}

const TabbedView = (props: ITabbedView) => {
    const { pathStyle: _pathStyle, availablePathKeys, ...tabsProps } = props

    const pathStyle = _pathStyle ?? 'slash'

    const { push: updateRoute, replace: replaceRoute } = useHistory()
    let { activeTab } = useParams() as any
    if (!activeTab && pathStyle === 'hash') {
        activeTab = location.hash.replace(/^#/, '').toLowerCase()
    }

    if (!!activeTab && !availablePathKeys.includes(activeTab)) {
        const correctedPath = location.pathname.replace(`/${activeTab}`, '')
        replaceRoute(correctedPath + location.search)
    }
    const inferredActiveKey = !activeTab ? tabsProps.defaultActiveKey ?? undefined : activeTab

    return (
        <Tabs
            {...tabsProps}
            activeKey={tabsProps.activeKey ?? inferredActiveKey}
            onChange={(key) => {
                const currPath = location.pathname

                if (pathStyle === 'slash') {
                    let nextPath = currPath.replace(new RegExp(`/(${availablePathKeys.join('|')})$`, 'i'), '')
                    if (availablePathKeys.includes(key)) {
                        nextPath += `/${key}`
                    }

                    updateRoute(nextPath)
                } else {
                    let nextPath = currPath
                    if (availablePathKeys.includes(key)) {
                        nextPath += `#${key}`
                    }

                    replaceRoute(nextPath)
                }
            }}
        />
    )
}

export default TabbedView
